import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { updateOfferProduct } from "../../../api/offerProduct";
import { alertError, alertSuccess } from "../../../utils/logger";
import LoadingDialog from "./LoadingDialog";

const ChangeOfferProductUnitsDialog = (props) => {
  const { title, open, setOpen, data, onSave } = props;

  const [loading, setLoading] = useState(false);
  const [units, setUnits] = useState("");

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  useEffect(() => {
    if (open) {
      setUnits(data?.def_unidades ?? "");
    }
  }, [open, data]);

  function handleClose() {
    setOpen(false);
    setUnits("");
  }

  function validateUnits() {
    if (units === "" || units === null || units === undefined) {
      alertError({
        error: "La cantidad es obligatoria.",
      });
      return false;
    }

    const normalizedUnits = Number(String(units).replace(",", "."));
    if (Number.isNaN(normalizedUnits) || normalizedUnits < 0) {
      alertError({
        error: "La cantidad debe ser un numero mayor o igual que 0.",
      });
      return false;
    }

    return true;
  }

  function saveUnits() {
    if (!validateUnits()) {
      return;
    }

    const normalizedUnits = Number(String(units).replace(",", "."));
    const currentUnits = Number(data?.def_unidades ?? 0);

    if (normalizedUnits === currentUnits) {
      handleClose();
      return;
    }

    setLoading(true);

    updateOfferProduct(
      data?.producto_id,
      {
        ...data,
        def_unidades: normalizedUnits,
      },
      loggedUser?.accessToken
    )
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          alertSuccess({
            title: "Guardado",
            customMessage: "Cantidad actualizada con exito",
          });
          if (typeof onSave === "function") {
            onSave(res.data);
          }
          handleClose();
        }
      })
      .catch((error) => {
        alertError({
          error,
          customMessage: "No se ha podido actualizar la cantidad",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        aria-labelledby="change-offer-product-units-dialog"
        className="backdrop"
      >
        <DialogTitle id="change-offer-product-units-dialog">
          {title || "Cambiar unidades"}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Producto"
            value={data?.descripcion ?? ""}
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: true }}
            margin="normal"
            variant="outlined"
          />
          <TextField
            autoFocus
            fullWidth
            label="Nueva cantidad"
            value={units}
            onChange={(event) => setUnits(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                saveUnits();
              }
            }}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              min: 0,
              step: 0.01,
            }}
            margin="normal"
            variant="outlined"
            type="number"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            Cancelar
          </Button>
          <Button onClick={saveUnits} variant="outlined" color="primary">
            Actualizar
          </Button>
        </DialogActions>
      </Dialog>
      <LoadingDialog open={loading} />
    </>
  );
};

export default ChangeOfferProductUnitsDialog;
